import React from 'react';
import styles from './Skeleton.module.css';

class Skeleton extends React.Component {
  render() {
    const { variant = 'rect', width, height, lines = 3, animate = true } = this.props;

    const cls = [
      styles.skeleton,
      animate ? styles.animate : '',
      variant === 'circle' ? styles.circle : '',
      variant === 'text'   ? styles.text   : '',
    ].filter(Boolean).join(' ');

    if (variant === 'text') {
      return (
        <div>
          {Array.from({ length: lines }).map((_, i) => (
            <div
              key={i}
              className={cls}
              style={{
                width:  i === lines - 1 ? '70%' : (width || '100%'),
                height: height || '12px',
                marginBottom: '6px',
              }}
            />
          ))}
        </div>
      );
    }

    if (variant === 'card') {
      return (
        <div
          className={cls}
          style={{
            width:  width  || '100%',
            height: height || '120px',
            borderRadius: 'var(--radius-lg)',
          }}
        />
      );
    }

    return (
      <div
        className={cls}
        style={{
          width:  width  || '100%',
          height: height || '16px',
        }}
      />
    );
  }
}

export default Skeleton;
